export default __webpack_public_path__ + "static/media/robots.607cdd6a.txt";